import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-client-from',
  templateUrl: './client-from.component.html',
  styleUrls: ['./client-from.component.css']
})
export class ClientFromComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/client/client-from/client-from.component.ts